import { SearchspringFetcher } from '../classes/searchspring-fetcher'
import { normaliseResults } from '../helpers/normalisers'
import { generateSearchspringProvider } from './provider'

export class SearchspringProduct extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { handle } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('resultsPerPage', 1)
    this.params.set('bgfilter.handle', handle)

    super.updateParams()
  }
}

export const SearchspringProductProvider = generateSearchspringProvider(SearchspringProduct, (results) => {
  return {
    ...results,
    results: normaliseResults(results.results)
  }
})
